import i18n from 'i18next';

export const buildInvalidFieldTranslation = (
  fieldNameTranslationKey: string,
) => i18n.t('validation.invalidField', { fieldName: i18n.t(fieldNameTranslationKey) });

const SUPPORTER_EMAIL_SUFFIX = '.supporter';
export const formatSupporterEmail = (email: string, suffixTranslationKey: string): string => {
  if (!email.endsWith(SUPPORTER_EMAIL_SUFFIX)) {
    return email;
  }
  const translatedSuffix = i18n.t(suffixTranslationKey);
  const processedEmail = email.substring(0, email.length - SUPPORTER_EMAIL_SUFFIX.length);
  return `${processedEmail} ${translatedSuffix}`;
};
